var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _ppt;
/**
 * Returns the reference datetime from which to compute other time incidents.
 * @returns A datetime corresponding to the start time of the performance timeline.
 */
export var getPerformanceReferenceTime = function () {
    return new Date(performance.timeOrigin);
};
/**
 * Returns a datetime of a measurement.
 * @returns A datetime
 */
export var computePerformanceTime = function (msDelta) {
    if (msDelta === void 0) { msDelta = 0; }
    return new Date(new Date(performance.timeOrigin).getTime() + msDelta);
};
/**
 * Gets all resource performance metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns `PerformanceResourceTiming[]`
 */
var getResourcePerformanceMetrics = function (obsPerfList) {
    return (obsPerfList || performance).getEntriesByType("resource");
};
/**
 * Gets a resource's performance metric data.
 * @param resource a resource url
 * @param obsPerfList optional list of `PerformanceEntry`
 * @returns an object like `ResourceMetric`
 */
export var getResourcePerformanceMetric = function (resource, obsPerfList) {
    var rpm = getResourcePerformanceMetrics(obsPerfList).find(function (r) { return r.name === resource; });
    return {
        decodedBodySize: rpm.decodedBodySize,
        encodedBodySize: rpm.encodedBodySize,
        kind: "resource",
        latency: rpm.responseEnd - rpm.startTime,
        transactionName: '',
        transferSize: rpm.transferSize,
        url: rpm.name,
    };
};
/**
 * Gets all paint performance metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns `PerformancePaintTiming[]`
 */
var getPaintPerformanceMetrics = function (obsPerfList) {
    return (obsPerfList || performance).getEntriesByType("paint");
};
/**
 * Gets all paint metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns an array of objects like `PaintMetric`
 */
export var getPaintMetrics = function (obsPerfList) {
    return getPaintPerformanceMetrics(obsPerfList).map(function (pp) { return ({
        kind: "paint",
        latency: pp.startTime,
        type: pp.name,
    }); });
};
/**
 * Gets a paint metric by type, from what's currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns an object like `PaintMetric`
 */
export var getPaintMetric = function (type, obsPerfList) {
    return getPaintMetrics(obsPerfList).find(function (r) { return r.type === type; });
};
/**
 * Gets all navigation performance metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns `PerformanceNavigationTiming[]`
 */
var getNavigationPerformanceMetrics = function (obsPerfList) {
    return (obsPerfList || performance).getEntriesByType("navigation");
};
/**
 * Gets navigation metric by type, from what's currently recorded in the performance timeline.
 * @param type the `NavigationType`.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns an object like `NavigationMetric`
 */
export var getNavigationMetric = function (type, obsPerfList) {
    var np = getNavigationPerformanceMetrics(obsPerfList).find(function (npm) { return npm.type === type; });
    return {
        duration: np.duration,
        kind: "navigation",
        type: np.type,
        url: np.name,
    };
};
/**
 * Gets all element performance metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns `PerformanceElementTiming[]`
 */
var getElementPerformanceMetrics = function (obsPerfList) {
    return (obsPerfList || performance).getEntriesByType("element");
};
/**
 *
 * @param identifier the value of the elementtiming attribute implemented in your client code.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns an object like `ElementMetric`
 */
export var getElementPerformanceMetric = function (identifier, obsPerfList) {
    var ep = getElementPerformanceMetrics(obsPerfList).find(function (epm) { return epm.identifier === identifier; });
    return {
        element: ep.element.outerHTML,
        id: ep.id || ep.identifier,
        identifier: ep.identifier,
        kind: "element",
        loadTime: ep.loadTime,
        renderTime: ep.renderTime,
        url: ep.url
    };
};
/**
 * Gets all navigation performance metrics currently recorded in the performance timeline.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns `PerformanceNavigationTiming[]`
 */
var getMeasurePerformanceMetrics = function (obsPerfList) {
    return (obsPerfList || performance).getEntriesByType("measure");
};
/**
 * Gets navigation metric by type, from what's currently recorded in the performance timeline.
 * @param type the `NavigationType`.
 * @param obsPerfList an optional parameter for use with leveraging the performance observer api.
 * @returns an object like `NavigationMetric`
 */
export var getMeasureMetric = function (measurementName, obsPerfList) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var np = getMeasurePerformanceMetrics(obsPerfList).find(function (npm) { return npm.name === measurementName; });
    return {
        // @ts-ignore
        detail: np.detail,
        // @ts-ignore
        decodedBodySize: (_b = (_a = np.detail) === null || _a === void 0 ? void 0 : _a.resourceMeasurement) === null || _b === void 0 ? void 0 : _b.decodedBodySize,
        // @ts-ignore
        encodedBodySize: (_d = (_c = np.detail) === null || _c === void 0 ? void 0 : _c.resourceMeasurement) === null || _d === void 0 ? void 0 : _d.encodedBodySize,
        // @ts-ignore
        transferSize: (_f = (_e = np.detail) === null || _e === void 0 ? void 0 : _e.resourceMeasurement) === null || _f === void 0 ? void 0 : _f.transferSize,
        kind: ((_h = (_g = np) === null || _g === void 0 ? void 0 : _g.detail) === null || _h === void 0 ? void 0 : _h.isGQL) ? "gql" : np.entryType,
        latency: np.duration,
        startTime: np.startTime,
        transactionName: np.name,
        // @ts-ignore
        url: (_k = (_j = np.detail) === null || _j === void 0 ? void 0 : _j.resourceMeasurement) === null || _k === void 0 ? void 0 : _k.name,
    };
};
/**
 * ForEach for async callbacks.
 * @param array Collection to iterate through
 * @param callback async function to await for each incident in the collection.
 */
export function asyncForEach(array, callback) {
    return __awaiter(this, void 0, void 0, function () {
        var index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    index = 0;
                    _a.label = 1;
                case 1:
                    if (!(index < array.length)) return [3 /*break*/, 4];
                    return [4 /*yield*/, callback(array[index], index, array)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    index++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Merges a `sourceConfig` to a `destinationConfig`.
 * @param destinationConfig
 * @param sourceConfig
 * @returns the `destinationConfig` overwriting scalar fields (string, boolean, number) and merging vector fields (array).
 */
export var mergeConfig = function (destinationConfig, sourceConfig) {
    var _a, _b, _c, _d, _e, _f;
    var _g, _h, _j, _k, _l, _m;
    destinationConfig.apiURL = sourceConfig.apiURL || destinationConfig.apiURL; // TODO: figure out how to resolve these 3 fields
    destinationConfig.app = sourceConfig.app || destinationConfig.app;
    destinationConfig.environment = sourceConfig.environment || destinationConfig.environment;
    (_a = (destinationConfig.elementIds || (destinationConfig.elementIds = []))).push.apply(_a, (((_g = sourceConfig.elementIds) === null || _g === void 0 ? void 0 : _g.filter(function (eid) { return !destinationConfig.elementIds.includes(eid); })) || []));
    (_b = (destinationConfig.navigationTypes || (destinationConfig.navigationTypes = []))).push.apply(_b, (((_h = sourceConfig.navigationTypes) === null || _h === void 0 ? void 0 : _h.filter(function (nt) { return !destinationConfig.navigationTypes.includes(nt); })) || []) || []);
    (_c = (destinationConfig.paintTypes || (destinationConfig.paintTypes = []))).push.apply(_c, (((_j = sourceConfig.paintTypes) === null || _j === void 0 ? void 0 : _j.filter(function (pt) { return !destinationConfig.paintTypes.includes(pt); })) || []) || []);
    (_d = (destinationConfig.resources || (destinationConfig.resources = []))).push.apply(_d, (((_k = sourceConfig.resources) === null || _k === void 0 ? void 0 : _k.filter(function (r) { return !destinationConfig.resources.find(function (r2) { return r2.name === r.name; }); })) || []) || []);
    (_e = (destinationConfig.gqlResources || (destinationConfig.gqlResources = []))).push.apply(_e, (((_l = sourceConfig.gqlResources) === null || _l === void 0 ? void 0 : _l.filter(function (r) { return !destinationConfig.gqlResources.find(function (r2) { return r2.endpoint === r.endpoint; }); })) || []) || []);
    (_f = (destinationConfig.ignoreErrors || (destinationConfig.ignoreErrors = []))).push.apply(_f, (((_m = sourceConfig.ignoreErrors) === null || _m === void 0 ? void 0 : _m.filter(function (r) { return !destinationConfig.ignoreErrors.find(function (r2) { return r2 === r; }); })) || []) || []);
    return destinationConfig;
};
/**
 * Validates a `KeyperConfig`.
 * @param config
 * @returns `valid` or a config object with the invalid fields populated.
 */
export var validateConfig = function (config, remoteFlow) {
    var invalidFields = {};
    remoteFlow || typeof config.apiURL === 'string' || (function () {
        throwWarning("keyper: apiURL is invalid.");
        invalidFields.apiURL = config.apiURL;
    })();
    remoteFlow || typeof config.app === 'string' || (function () {
        throwWarning("keyper: app is invalid.");
        invalidFields.app = config.app;
    })();
    remoteFlow || typeof config.environment === 'string' || (function () {
        throwWarning("keyper: environment is invalid.");
        invalidFields.environment = config.environment;
    })();
    remoteFlow || (Array.isArray(config.elementIds) &&
        (!config.elementIds.length || config.elementIds.every(function (eid) { return typeof eid === 'string'; }))) || (function () {
        throwWarning("keyper: elementIds are invalid.");
        invalidFields.elementIds = config.elementIds;
    })();
    remoteFlow || (Array.isArray(config.navigationTypes) &&
        (!config.navigationTypes.length || config.navigationTypes.every(function (nt) { return ["back_forward", "navigate", "prerender", "reload"].includes(nt); }))) || (function () {
        throwWarning("keyper: navigationTypes are invalid.");
        invalidFields.navigationTypes = config.navigationTypes;
    })();
    remoteFlow || (Array.isArray(config.paintTypes) &&
        (!config.paintTypes.length || config.paintTypes.every(function (pt) { return ["first-contentful-paint", "first-paint"].includes(pt); }))) || (function () {
        throwWarning("keyper: paintTypes are invalid.");
        invalidFields.paintTypes = config.paintTypes;
    })();
    remoteFlow || (Array.isArray(config.resources) &&
        (!config.resources.length || config.resources.every(function (r) { return typeof r.name === 'string' && typeof r.url === 'string'; }))) || (function () {
        throwWarning("keyper: resources are invalid.");
        invalidFields.resources = config.resources;
    })();
    remoteFlow || (Array.isArray(config.gqlResources) &&
        (!config.gqlResources.length || config.gqlResources.every(function (r) { return typeof r.name === 'string' && typeof r.endpoint === 'string' && Array.isArray(r.opNames) && r.opNames.every(function (opName) { return typeof opName === 'string'; }); }))) || (function () {
        throwWarning("keyper: gqlResources are invalid.");
        invalidFields.gqlResources = config.gqlResources;
    })();
    remoteFlow || (Array.isArray(config.ignoreErrors) &&
        (!config.ignoreErrors.length || config.ignoreErrors.every(function (ie) { return typeof ie === 'string'; }))) || (function () {
        throwWarning("keyper: gqlResources are invalid.");
        invalidFields.ignoreErrors = config.ignoreErrors;
    })();
    return Object.keys(invalidFields).length ? invalidFields : "valid";
};
function throwWarning(msg) {
    console.warn(msg);
}
/** Special keys for internal use. */
export var keys;
(function (keys) {
    /** The key used to store previously recorded transactions with (sessionStorage) */
    keys["previousTransaction"] = "keyper_previous_transaction";
})(keys || (keys = {}));
export function uuidv4() {
    // @ts-ignore
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
}
//# sourceMappingURL=utils.js.map